import { render, staticRenderFns } from "./zhuanye.vue?vue&type=template&id=da74c9da&scoped=true"
import script from "./zhuanye.vue?vue&type=script&lang=js"
export * from "./zhuanye.vue?vue&type=script&lang=js"
import style0 from "./zhuanye.vue?vue&type=style&index=0&id=da74c9da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da74c9da",
  null
  
)

export default component.exports